//@flow
import React from "react"
import { Field, reduxForm } from "redux-form"
import {
  InputField,
  CheckboxField,
  Label,
  FormGroup,
  Error,
  FormRow,
  FormCol,
  Note
} from "../UI/Form"
import { PrimaryButton, SecondaryButton, DangerButton } from "../UI/Buttons"
import validate from "./validate"
import type { UserFormProps } from "./types"

const UserForm = ({
  handleSubmit,
  handleCancel,
  handleChange,
  handleDelete,
  error,
  isNew,
  pristine,
  id
}: UserFormProps) =>
  <form onSubmit={handleSubmit}>
    <Note>
      Note: {!id ? "All fields REQUIRED" : "Updating password is OPTIONAL"}
    </Note>

    <FormRow>
      <FormCol grow={2}>
        <FormGroup>
          <Label htmlFor="name">Name</Label>
          <Field
            name="name"
            component={InputField}
            type="text"
            onChange={handleChange}
          />
        </FormGroup>
      </FormCol>
      <FormCol grow={1}>
        <Note>This is the user's real name.</Note>
      </FormCol>
    </FormRow>

    <FormRow>
      <FormCol grow={2}>
        <FormGroup>
          <Label htmlFor="email">Email</Label>
          <Field
            name="email"
            component={InputField}
            type="email"
            autoComplete="off"
            autoCorrect="off"
            spellCheck="off"
            onChange={handleChange}
          />
        </FormGroup>
      </FormCol>
      <FormCol grow={1}>
        <Note />
      </FormCol>
    </FormRow>

    <FormRow>
      <FormCol grow={2}>
        <FormGroup>
          <Label htmlFor="password">Password</Label>
          <Field
            name="password"
            component={InputField}
            type="password"
            autoComplete="off"
            autoCorrect="off"
            spellCheck="off"
            onChange={handleChange}
          />
        </FormGroup>
      </FormCol>
      <FormCol grow={1}>
        <Note>
          The password the user will need to login. This is not emailed to the
          user in any form of a confirmation email so you will need to let them
          know their password privately.
        </Note>
      </FormCol>
    </FormRow>

    <FormRow>
      <FormCol grow={2}>
        <FormGroup>
          <Field
            name="admin"
            labelText="Admin access enabled?"
            component={CheckboxField}
            onChange={handleChange}
          />
        </FormGroup>
      </FormCol>
      <FormCol grow={1}>
        <Note>
          When checked, this user will be able to access the admin. If left
          unchecked the user will be taken to a waiting screen when they log in.
        </Note>
      </FormCol>
    </FormRow>

    {error &&
      <Error>
        {error}
      </Error>}

    <FormRow>
      <FormCol grow={2}>
        <FormRow>
          <FormCol grow={1} />
          <FormCol grow={1}>
            <SecondaryButton block={true} onClick={handleCancel}>
              Cancel
            </SecondaryButton>
          </FormCol>
          <FormCol grow={1}>
            <PrimaryButton block={true} disabled={!isNew && pristine}>
              {isNew ? "Create" : "Update"} User
            </PrimaryButton>
          </FormCol>
        </FormRow>
      </FormCol>
      <FormCol grow={1}>
        <Note>
          When you create a new user they receive a confirmation email.
        </Note>
      </FormCol>
    </FormRow>
    {isNew
      ? ""
      : <div>
          <FormRow>
            <FormCol grow={2}>
              <FormRow>
                <FormCol grow={1} />
                <FormCol grow={1} />
                <FormCol grow={1}>
                  <DangerButton block={true} onClick={handleDelete}>
                    Delete User
                  </DangerButton>
                </FormCol>
              </FormRow>
            </FormCol>
            <FormCol grow={1}>
              <Note>This cannot be undone.</Note>
            </FormCol>
          </FormRow>
        </div>}
  </form>

export default reduxForm({
  form: "user",
  enableReinitialize: true,
  validate
})(UserForm)



// WEBPACK FOOTER //
// ./src/Users/UserForm.js